import { useMemo } from 'react'
import { type CompleteEvent, Model } from 'survey-core'
import { Survey } from 'survey-react-ui'
import 'survey-core/survey-core.min.css'

interface Props {
  surveyJson: any
  onComplete: (survey: Model, options: CompleteEvent) => void
  onLoad?: (survey: Model) => void
  themeJson?: any
  answers?: Record<string, any>
}

export function SurveyDisplay ({
  surveyJson,
  onComplete,
  onLoad,
  themeJson,
  answers
}: Props): JSX.Element {
  const surveyModel = useMemo(() => {
    const model = new Model(surveyJson)

    const appliedTheme = themeJson ?? {
      isPanelless: true,
      cssVariables: {
        '--sjs-general-backcolor': 'transparent',
        '--sjs-general-backcolor-dim': 'transparent',
        '--sjs-paper-backcolor': 'transparent',
        '--sjs-paper-shadow': 'none',
        '--sjs-question-panel-padding': '0px',
        '--sd-base-padding': '0px',
        '--sd-base-vertical-padding': '0px',
        '--sd-page-vertical-padding': '0px'
      }
    }

    model.applyTheme(appliedTheme)
    model.widthMode = 'responsive'
    model.showTitle = false
    model.showQuestionNumbers = 'off'
    model.showNavigationButtons = 'bottom'
    model.showCompletedPage = false
    model.data = answers ?? {}

    model.onComplete.add(onComplete)

    onLoad?.(model)

    return model
  }, [surveyJson, themeJson, onComplete, onLoad, answers])

  return (
    <div style={{ width: '100%' }}>
      <Survey model={surveyModel} />
    </div>
  )
}
